import { Icons } from '@/components/Shares/Icons';
import { type MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { Menu, Text } from '@mantine/core';
export type PopupMenuItemProps = {
  icon: string;
  title: string;
  modal: MODAL | null;
};
export const PopupMenuItem: React.FC<PopupMenuItemProps> = ({
  icon,
  title,
  modal
}) => {
  const {
    setOpenModal
  } = useModalAction();
  return <Menu.Item leftSection={<Icons className={icon} fontSize={24} />} onClick={() => setOpenModal(modal)}>
      <Text tt="uppercase" fw={700} fz={12}>
        {title}
      </Text>
    </Menu.Item>;
};